import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CountdownTimer = ({ targetDate, duration }) => {
  const { t } = useTranslation();
  const [complete, setComplete] = useState(false);
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span key={interval}>
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date().getTime();
      var startDate = new Date(targetDate);
      var startTimeWithOffset = startDate.getTime() + duration * 1000;
      const elapsedTime = currentTime - startTimeWithOffset;
      const remaining = Math.max(duration - elapsedTime, 0);
      if (remaining === 0) {
        setComplete(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate, duration]);
  return (
    <>
      {timerComponents.length ? (
        <>
          <div className="countdown-timer">
            {" "}
            <img src="/image/chronometer.png" className="chronometer" alt="time" />{" "}
            {timerComponents}
          </div>
        </>
      ) : complete ? (
        <div className="begin_the_competition">
          The competition has concluded. Please check the results
        </div>
      ) : (
        <div className="begin_the_competition">{t("74")}</div>
      )}
    </>
  );
};

export default CountdownTimer;
